import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { matchPath, withRouter } from 'react-router-dom';
import { fetchAuthor, updateAuthorPage } from '../../actions';
import uploadFile from '../../services/s3';
import PronounPicker from './pronoun-picker';
import ShowProfile from './show-profile';

function PersonalProfile(props) {
  const [errorMsg, setErrorMsg] = useState('');
  const [editing, setEditing] = useState(false);
  const [name, setName] = useState('');
  const [username, setUsername] = useState('');
  const [location, setLocation] = useState('');
  const [pronouns, setPronouns] = useState('');
  const [education, setEducation] = useState('');
  const [description, setDescription] = useState('');
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState('');
  const [welcome, setWelcome] = useState(false);

  const firstTime = matchPath(props.location.pathname, {
    path: '*/init*',
  });

  const resetEditor = () => {
    if (!props.currentAuthor || !props.currentAuthor.id) return;
    setName(props.currentAuthor.name || '');
    setUsername(props.currentAuthor.username || '');
    setLocation(props.currentAuthor.location || '');
    setPronouns(props.currentAuthor.pronouns || '');
    setEducation(props.currentAuthor.education || '');
    setDescription(props.currentAuthor.description || '');
    setPreview(props.currentAuthor.profpic);
  };

  useEffect(() => {
    props.fetchAuthor();
    if (firstTime) {
      setEditing(true);
      setWelcome(true);
    }
  }, []);

  useEffect(() => {
    if (props.error && props.error !== '') {
      props.fetchAuthor();
      setErrorMsg(props.error);
    }
  }, [props.error]);

  useEffect(() => {
    resetEditor();
  }, [props.currentAuthor]);

  const onFileUpload = (e) => {
    const thisFile = e.target.files[0];
    // Handle null file
    // Get url of the file and set it to the src of preview
    if (thisFile) {
      setPreview(window.URL.createObjectURL(thisFile));
      setFile(thisFile);
    }
  };
  const stopEditing = () => {
    if (!username || !name) {
      setErrorMsg('Name, username must be non-empty!');
      return;
    }
    const author = {
      name,
      location,
      pronouns,
      education,
      description,
      username,
    };
    if (file) {
      uploadFile(file).then((url) => {
        author.profpic = url;
        props.updateAuthorPage(author);
      });
    } else {
      props.updateAuthorPage(author);
    }
    setEditing(false);
    setFile(null);
  };

  const renderPage = () => {
    if (editing) {
      return (
        <div id="individual-page-edit">
          {errorMsg ? <p className="error-msg">{errorMsg}</p> : <></>}
          {welcome ? <p className="welcome-msg">Step 2: Fill in your profile! Save when done.</p> : <></>}
          <img className="profile-pic" alt="" src={preview || ''} />
          <label className="custom-file-upload" htmlFor="file-upload">
            <input type="file" id="file-upload" onChange={onFileUpload} />
            Change <i className="fas fa-camera-retro" alt="Picture" />
          </label>
          <div className="bio-item">
            <h3>Name: </h3>
            <input type="text" className="editbox" placeholder="name" value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div className="bio-item">
            <h3>Username: </h3>
            <input type="text" className="editbox" placeholder="name" value={username} onChange={(e) => setUsername(e.target.value)} />
          </div>
          <div className="bio-item">
            <h3>Location:</h3>
            <input type="text" className="editbox" placeholder="location" value={location} onChange={(e) => setLocation(e.target.value)} />
          </div>
          <div className="bio-item">
            <h3>Pronouns: </h3>
            <PronounPicker pronouns={pronouns} savePronouns={setPronouns} />
          </div>
          <div className="bio-item">
            <h3>Education: </h3>
            <input type="text" className="editbox" placeholder="education" value={education} onChange={(e) => setEducation(e.target.value)} />
          </div>
          <div className="profile-description">
            <h2>Bio </h2>
            <textarea type="text" className="editbox-description" placeholder="share your story!" value={description} onChange={(e) => setDescription(e.target.value)} />
          </div>
          <button type="button" className="edit-profile-btn" onClick={() => { stopEditing(); setWelcome(false); }}>
            <span className="save">SAVE</span>
          </button>
        </div>
      );
    } else {
      return (
        <div id="individual-page-edit">
          {errorMsg ? <p className="error-msg">{errorMsg}</p> : <></>}
          <div className="profile-btn">
            <button type="button" className="edit-profile-btn" onClick={() => { setEditing(true); setErrorMsg(''); }}>
              <span className="edit">EDIT</span>
            </button>
          </div>
          {props.currentAuthor ? <ShowProfile current={props.currentAuthor} /> : <></>}
        </div>
      );
    }
  };

  return (
    <>
      {renderPage()}
    </>
  );
}

const mapStateToProps = (state, ownProps) => (
  {
    currentAuthor: state.author.current,
    error: state.author.error,
  }
);
export default withRouter(connect(mapStateToProps, { fetchAuthor, updateAuthorPage })(PersonalProfile));
